/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AssetAccountRequest } from './AssetAccountRequest';
import {
    AssetAccountRequestFromJSON,
    AssetAccountRequestFromJSONTyped,
    AssetAccountRequestToJSON,
    AssetAccountRequestToJSONTyped,
} from './AssetAccountRequest';

/**
 * 
 * @export
 * @interface SaveAssetPersonalDataInventoryPart
 */
export interface SaveAssetPersonalDataInventoryPart {
    /**
     * 
     * @type {string}
     * @memberof SaveAssetPersonalDataInventoryPart
     */
    causesDescription: string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveAssetPersonalDataInventoryPart
     */
    phoneNumber: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SaveAssetPersonalDataInventoryPart
     */
    hasOwnAccount: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof SaveAssetPersonalDataInventoryPart
     */
    hasFurtherAccount: boolean | null;
    /**
     * 
     * @type {Array<AssetAccountRequest>}
     * @memberof SaveAssetPersonalDataInventoryPart
     */
    accounts: Array<AssetAccountRequest>;
}

/**
 * Check if a given object implements the SaveAssetPersonalDataInventoryPart interface.
 */
export function instanceOfSaveAssetPersonalDataInventoryPart(value: object): value is SaveAssetPersonalDataInventoryPart {
    if (!('causesDescription' in value) || value['causesDescription'] === undefined) return false;
    if (!('phoneNumber' in value) || value['phoneNumber'] === undefined) return false;
    if (!('hasOwnAccount' in value) || value['hasOwnAccount'] === undefined) return false;
    if (!('hasFurtherAccount' in value) || value['hasFurtherAccount'] === undefined) return false;
    if (!('accounts' in value) || value['accounts'] === undefined) return false;
    return true;
}

export function SaveAssetPersonalDataInventoryPartFromJSON(json: any): SaveAssetPersonalDataInventoryPart {
    return SaveAssetPersonalDataInventoryPartFromJSONTyped(json, false);
}

export function SaveAssetPersonalDataInventoryPartFromJSONTyped(json: any, ignoreDiscriminator: boolean): SaveAssetPersonalDataInventoryPart {
    if (json == null) {
        return json;
    }
    return {
        
        'causesDescription': json['causesDescription'],
        'phoneNumber': json['phoneNumber'],
        'hasOwnAccount': json['hasOwnAccount'],
        'hasFurtherAccount': json['hasFurtherAccount'],
        'accounts': ((json['accounts'] as Array<any>).map(AssetAccountRequestFromJSON)),
    };
}

export function SaveAssetPersonalDataInventoryPartToJSON(json: any): SaveAssetPersonalDataInventoryPart {
    return SaveAssetPersonalDataInventoryPartToJSONTyped(json, false);
}

export function SaveAssetPersonalDataInventoryPartToJSONTyped(value?: SaveAssetPersonalDataInventoryPart | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'causesDescription': value['causesDescription'],
        'phoneNumber': value['phoneNumber'],
        'hasOwnAccount': value['hasOwnAccount'],
        'hasFurtherAccount': value['hasFurtherAccount'],
        'accounts': ((value['accounts'] as Array<any>).map(AssetAccountRequestToJSON)),
    };
}

